import { colors, fonts } from 'components/styles/variables';
import { useFilterContext } from 'contexts/OnboardingFilterContext';
import { SrpBodyTypeName } from 'types/srpFilters';
import { bodyTypes } from 'components/Srp/SearchFilter/BodyStylesFilter/BodyTypesFilter';
import { SrpFilterName } from 'types/srpFilters';
import { useEffect } from 'react';
import useEvents from 'lib/hooks/useEvents';
import viewEvent from 'lib/Tracking/Onboarding/ViewEvent';
import { SourcePages } from 'lib/EventSchema';
import { filterTruthyKeys } from 'lib/Utilities';
import ToggleButton from '../Buttons/ToggleButton';
import AutolistLogo from '../Logo';
import Button from '../Buttons/Button';
import { OnboardingComponentProps } from '../Modal';

type BodyType = {
  [key in SrpBodyTypeName]: boolean;
};

const BodyStyle = ({ t, onNextStep }: OnboardingComponentProps): JSX.Element => {
  const logger = useEvents();
  const { filterData, updateFilterData } = useFilterContext();
  const existingBodyTypeValues = filterData[SrpFilterName.BodyTypes];

  const onSelect = (val: BodyType): void => {
    updateFilterData({
      [SrpFilterName.BodyTypes]: {
        ...existingBodyTypeValues,
        ...val,
      },
    });
  };

  const onClick = (): void => {
    const selectedKeys = filterTruthyKeys(existingBodyTypeValues);
    onNextStep({ selection: selectedKeys });
  };

  useEffect(() => {
    logger.log(viewEvent({ sourcePage: SourcePages.OnboardingBodyStyle }));
  }, [logger]);

  return (
    <>
      <div className="bodystyle-step-container">
        <div className="bodystyle-content">
          <AutolistLogo />
          <h5 className="header">{t('onboarding.bodyStyleScreen.header')}</h5>
          <div className="subtitle">{t('onboarding.bodyStyleScreen.subText')}</div>
          <div className="bodystyle-options-container">
            {bodyTypes.map((bodyType) => {
              const bodyTypeLabel =
                bodyType === 'passenger_cargo_van'
                  ? 'Vans'
                  : t(`srp.filters.bodyStyles.${bodyType}`);

              const bodyTypeOption = {
                label: bodyTypeLabel,
                value: bodyType,
              };
              return (
                <ToggleButton
                  answer={bodyTypeOption}
                  onClick={(val): void => onSelect(val as BodyType)}
                />
              );
            })}
          </div>
        </div>
        <div>
          <Button onClick={onClick}>{t('onboarding.next')}</Button>
        </div>
      </div>

      <style jsx>{`
        .bodystyle-step-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 564px;
          justify-content: space-between;
          width: 295px;
        }
        .bodystyle-content {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .input-slider-block-container {
          width: 295px;
        }
        .header {
          text-align: center;
          font-family: ${fonts.default};
          font-weight: 700;
          font-size: 22px;
          line-height: 32px;
          letter-spacing: 0.2px;
          margin: 0;
          margin-bottom: 20px;
        }
        .subtitle {
          text-align: center;
          font-family: ${fonts.default};
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.2px;
          color: ${colors.G3};
          margin-bottom: 20px;
        }

        .bodystyle-options-container {
          width: 298px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-bottom: 20px;
        }
      `}</style>
      <style jsx global>
        {`
          .bodystyle-options-container .toggle-button {
            flex: 1 1 50%;
            height: 44px;
          }
        `}
      </style>
    </>
  );
};

export default BodyStyle;
